import { route } from '@/ziggy-shim';
import { api, apiConfig } from './LaravelClient';

export default {
  async index(projectId: Id, packageId: Id) {
    return await api(
      route('api.v1.packages.tenders.index', {
        project: projectId,
        package: packageId,
      }),
      'get',
    );
  },

  async issue(projectId: Id, packageId: Id, data: ApiRequests['api.v1.packages.tenders.issue']) {
    return await api(
      route('api.v1.packages.tenders.issue', {
        project: projectId,
        package: packageId,
      }),
      'post',
      { data },
    );
  },

  async selectWinner(projectId: Id, packageId: Id, data: ApiRequests['api.v1.packages.tenders.select-winner']) {
    return await api(
      route('api.v1.packages.tenders.select-winner', {
        project: projectId,
        package: packageId,
      }),
      'post',
      {
        data,
      },
    );
  },

  async submit(tenderId: Id, signedParams: unknown) {
    return await apiConfig(route('api.v1.subcontractor.tenders.submit', tenderId), 'post', {
      params: signedParams,
      paramsSerializer: {
        serialize: (params) => {
          return new URLSearchParams(params).toString();
        },
      },
    });
  },

  async export(projectId: Id, packageId: Id) {
    return await api(
      route('api.v1.packages.tenders.export', {
        project: projectId,
        package: packageId,
      }),
      'post',
    );
  },
};
